import { View } from 'foundations-components/components/View';
import { Fragment, memo } from 'react';
import { EditorLoadingState } from '../../../editor-utilities/protected/components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const _ReplyEditorLoadingState = () => /*#__PURE__*/_jsxs(Fragment, {
  children: [/*#__PURE__*/_jsx(View, {
    blockSize: "49px",
    inlineSize: "100%",
    backgroundColor: "fill-surface-default",
    borderBlockStyle: "solid",
    borderBlockWidth: "100",
    borderBlockColor: "border-core-subtle",
    "data-loading": "true"
  }), /*#__PURE__*/_jsx(EditorLoadingState, {})]
});
_ReplyEditorLoadingState.displayName = 'ReplyEditorLoadingState';
export const ReplyEditorLoadingState = /*#__PURE__*/memo(_ReplyEditorLoadingState);